<template>
  <countdown :time="this.endTime" :transform="transform" tag="div" class="has-text-centered">
    <template slot-scope="props">
      <div
        class="columns is-mobile countdown is-variable is-1 is-size-2-tablet is-size-3 has-text-centered is-centered mb-4">
        <div class="column countdown__column">
          {{ props.days }} <span class="is-sr-only">{{ $t('general.day') }}</span>
          <p class="is-size-7 has-text-weight-bold countdown__unit" aria-hidden="true">{{ $t('general.day') }}</p>
        </div>
        <div class="column is-1 countdown__column">:</div>
        <div class="column countdown__column">
          {{ props.hours }} <span class="is-sr-only">{{ $t('general.hour') }}</span>
          <p class="is-size-7 has-text-weight-bold countdown__unit" aria-hidden="true">{{ $t('general.hour-abrev') }}
          </p>
        </div>
        <div class="column is-1 countdown__column">:</div>
        <div class="column countdown__column">
          {{ props.minutes }} <span class="is-sr-only">{{ $t('general.minutes') }}</span>
          <p class="is-size-7 has-text-weight-bold countdown__unit" aria-hidden="true">{{ $t('general.min-abrev') }}</p>
        </div>
        <div class="column is-1 countdown__column">:</div>
        <div class="column countdown__column">
          {{ props.seconds }} <span class="is-sr-only">{{ $t('general.sec') }}</span>
          <p class="is-size-7 has-text-weight-bold countdown__unit" aria-hidden="true">{{ $t('general.sec-abrev') }}</p>
        </div>
      </div>
    </template>
  </countdown>
</template>

<script>
import VueCountdown from '@chenfengyuan/vue-countdown'

export default {
  name: 'CountdownTimer',
  props: {
    endTime: Number,
  },
  components: {
    countdown: VueCountdown,
  },
  data() {
    return {}
  },

  methods: {
    transform(props) {
      Object.entries(props).forEach(([key, value]) => {
        // Adds leading zero
        const digits = value < 10 ? `0${value}` : value

        props[key] = `${digits}`
      })

      return props
    },
  },
}
</script>

<style scoped lang="scss">
.countdown {
  display: inline-flex;
  margin-bottom: 0 !important; // important for removing space in deal element
  font-variant-numeric: tabular-nums; //prevent fonts with different number widths from jumping

  &>.column {
    padding-bottom: 0;
  }
}

.countdown__unit {
  margin-top: -0.5rem;
}

@media screen and (min-width: 769px) {
  .countdown__unit {
    margin-top: -0.75rem;
  }
}
</style>
